import React, { useState, useEffect } from 'react';
import { connect} from 'react-redux';
import ActiveOrders from './dashboard/ActiveOrders';
import ActiveQuotes from './dashboard/ActiveQuotes';
import DashboardOrderHistory from './dashboard/DashboardOrderHistory'
import ActiveInvoices from './dashboard/ActiveInvoices';
import OrderService from '../services/OrderService';
import { withSelectedCustomer } from '../hooks/withSelectedCustomer';
import { withStorefrontConfig } from '../hooks/StorefrontSettingsContext';
import { useDashboardConfig, withDashboardConfig } from '../hooks/DashboardConfigContext';
import PropTypes from 'prop-types';
import MessageStandard from './MessageStandard';
import SearchIcon from './icons/Search';
import Loading from '../components/Loading';
import DashboardQuoteHistory from './dashboard/DashboardQuoteHistory'
import DashboardYourSelections from './dashboard/DashboardYourSelections';
import PricingHelper from '../helpers/PricingHelper';
import DashboardNews from './dashboard/DashboardNews'
import { DraggableContainer } from './dashboard/DraggableContainer';
import UserService from '../services/UserService';
import DashboardUserFavorite from './dashboard/DashboardUserFavorite'

export const Home = (props) => {
    const customerData = props.selectedCustomer;
    const [country, setCountry] = React.useState("");
    const storeData = props.StorefrontConfig;
    const [storefrontNumber, setStorefrontNumber] = React.useState(('00000' + storeData.storefrontNumber).slice(-5));
    const dashboardLabels = useDashboardConfig().labels;
    const showNewsSection = storeData.settingsList.UseDashboardNews == 1 ? true : false;
    const [invoiceData, setInvoiceData] = useState({ totalOpenInvoices: 0, headerResponse: [] });
    const [orderData, setOrderData] = useState({ totalActiveOrders: 0, headerOrdersResponse: [], salesOrdersResponse: [] });
    const [quoteData, setQuoteData] = useState({ totalOpenQuotes: 0, headerResponse: [] });
    const [monthlyTotals, setMonthlyTotals] = React.useState({});
    const [currencySymbol, setCurrencySymbol] = React.useState();
    const [currency, setCurrency] = React.useState();
    const [loading, setLoading] = React.useState(true);
    const [selectionData, setSelectionData] = useState()
    const [newsData, setNewsData] = useState({ headerResponse: [] });
    const [dashboardTopOrder, setDashboardTopOrder] = useState();
    const [dashboardBottomOrder, setDashboardBottomOrder] = useState();
    const [userFavoriteData, setUserFavoriteData] = useState([])
    const dashboardWidgets = [
        {
            id: 1,
            type: "DashboardTop",
            content: <ActiveOrders  availableStatuses={storeData.storefrontOrderQuoteStatuses} locale={storeData.locale} orderData={orderData} isFueling={props.isFueling} dashboardLabels={dashboardLabels} storeSettings={storeData} />
        },
        {
            id: 2,
            type: "DashboardTop",
            content: <ActiveQuotes availableStatuses={storeData.storefrontOrderQuoteStatuses} storeSettings={storeData} quoteData={quoteData} dashboardLabels={dashboardLabels} QuoteDayRange={storeData.settingsList.QuoteDayRange} />
        },
        {
            id: 3,
            type: "DashboardTop",
            content: <ActiveInvoices invoiceData={invoiceData} dashboardLabels={dashboardLabels} storeSettings={storeData} />
        },     
        {
            id: 1,
            type: "DashboardBottom",
            content: showNewsSection === true && <DashboardNews newsData={newsData} storeSettings={storeData} dashboardLabels={dashboardLabels} />
        },
        {
            id: 2,
            type: "DashboardBottom",
            content: <DashboardOrderHistory tdMoneyAlign={storeData.settingsList.TdMoneyAlign} dateFormat={storeData.settingsList.DateFormat} isFueling={props.isFueling} orderData={orderData} country={country} currency={currency} currencySymbol={currencySymbol} monthlyTotals={monthlyTotals} storefrontNumber={storefrontNumber} dashboardLabels={dashboardLabels} storeSettings={storeData} />
        },
        {
            id: 3,
            type: "DashboardBottom",
            content: <DashboardQuoteHistory tdMoneyAlign={storeData.settingsList.TdMoneyAlign} dateFormat={storeData.settingsList.DateFormat} isFueling={props.isFueling} quoteData={quoteData} currency={currency} country={country} storefrontNumber={storefrontNumber} dashboardLabels={dashboardLabels} QuoteDayRange={storeData.settingsList.QuoteDayRange} storeSettings={storeData} />
        },
        {
            id: 4,
            type: "DashboardBottom",
            content: <DashboardYourSelections selections={selectionData} storeSettings={storeData} />
        },
        {
            id: 5,
            type: "DashboardBottom",
            content: <DashboardUserFavorite userFavoriteList={userFavoriteData} dashboardLabels={dashboardLabels} storeSettings={storeData} />
        }
    ];


    useEffect(() => {
        let cancelled = false;
        (async () => {
            if (props?.selectedCustomer) {
                await getHomeData();
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [props.selectedCustomer, props.StorefrontConfig.locale]);


    const getHomeData = async () => {
        setLoading(true);
        await getDashboardConfigData();
        await getInvoiceData();
        await getSelectionData();
        await getOrderData();
        await getQuoteData();
        await getNewsData();
        await getUserFavoriteData();
        setLoading(false);
    }

    const getDashboardConfigData = () => {
        return UserService.getDashboardConfiguration().then((data) => {
            if (data) {
                setDashboardTopOrder(data.dashboardTopOrders);
                setDashboardBottomOrder(data.dashboardBottomOrders);
                //set favorites in the future.
            }
        });       
    }

    const getOrderData = () => {
        return OrderService.getDashboardOrders(customerData.id, storeData.storefront.id, customerData.companyCode).then((data) => {
            setCountry(customerData.address.country);
            if (data) {
                setOrderData(data);
                updateCurrencyInformation(data);    
                calculate12MonthTotals(data);
            }
            else {
                setOrderData({ totalActiveOrders: 0, headerOrdersResponse: [], salesOrdersResponse: [] })
            }
        });
    }

    const getQuoteData = () => {
        return OrderService.getDashboardQuotes(customerData.id, storeData.storefront.id, customerData.companyCode, 10,props.StorefrontConfig.settingsList.QuoteDayRange).then((data) => {
            if (data) {
                setQuoteData(data);
            }
            else {
                setQuoteData({ totalOpenQuotes: 0, headerResponse: [] })
               
            }
        });
    }

    const getInvoiceData = () => {
        return OrderService.getDashboardInvoices(customerData.id, storeData.storefront.id, customerData.companyCode, 10).then((data) => {
            if (data) {
                setInvoiceData(data);
            }
            else {
                setInvoiceData({ totalOpenQuotes: 0, headerResponse: [] })
            }
        });
    }

    const getSelectionData = () => {
        return OrderService.getDashboardFESelections(props.userEmail).then((data) => {
            if (data) {
                setSelectionData(data);
            }
            else {
                setSelectionData("");
            }
        });
    }
    const getUserFavoriteData = () => {
        return UserService.getUserFavoriteList().then((data) => {           
            if (data) {
                setUserFavoriteData(data);
            }
            else {
                setUserFavoriteData([]);
            }
        });
    }

    const getCurrencySymbol = (locale, currency) => (0).toLocaleString(locale, { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\d/g, '').trim();
    const calculate12MonthTotals = (data) => {
        let monthData = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];
        let dateOrderedMonthData = [];
        let currentYear = new Date().getFullYear();
       let currentMonth = new Date().getMonth();
        let oneYearData = data.salesOrdersResponse.filter(x => new Date(x.orderDate).getFullYear() === currentYear || new Date(x.orderDate).getFullYear() === currentYear - 1 && new Date(x.orderDate).getMonth() > new Date().getMonth());

        if (oneYearData && oneYearData.length > 0) {
            oneYearData.forEach((order) => {
                let monthNumber = new Date(order.orderDate).getMonth();
                let monthName = monthData[monthNumber];
                let isCurrentYear = new Date(order.orderDate).getFullYear() === currentYear;
                if (dateOrderedMonthData.some(x => x.month === monthName)) {
                    let index = dateOrderedMonthData.findIndex(x => x.month === monthName);
                    dateOrderedMonthData[index].total += order.total;
                }
                else {
                    dateOrderedMonthData.push({ month: monthName, total:order.total, currentYear: isCurrentYear });
                }                         
            });        
            for (let i = 0; i <= currentMonth; i++) {
                let monthName = monthData[i];
                if (!dateOrderedMonthData.some(x => x.month === monthName)) {
                    dateOrderedMonthData.push({ month: monthName, total: 0, currentYear: true });
                }
            }
            for (let i = currentMonth; i < 12; i++) {
                let monthName = monthData[i];               
                    if (!dateOrderedMonthData.some(x => x.month === monthName)) {
                        dateOrderedMonthData.push({ month: monthName, total: 0, currentYear: false });
                    }
            }
            dateOrderedMonthData.sort((a, b) => {
                if (a.currentYear === b.currentYear) {
                    return monthData.indexOf(a.month) - monthData.indexOf(b.month);
                }
                else {
                    return a.currentYear ? 1 : -1;
                }
            });
            setMonthlyTotals(dateOrderedMonthData);  
        }
        
    }
    const updateCurrencyInformation = (data) => {
        if (data && data.salesOrdersResponse && data.salesOrdersResponse.length > 0) {
            let updatedSymbol = getCurrencySymbol(PricingHelper.fetchLocale(country), data.salesOrdersResponse[0].priceCurrency.toLowerCase());
            setCurrency(data.salesOrdersResponse[0].priceCurrency.toLowerCase());
            setCurrencySymbol(updatedSymbol);
        }
    }
    const getNewsData = () => {
        return OrderService.getDashboardNews(storeData.storefront.id, 5).then((data) => {
            if (data) {
                setNewsData(data);
            }
            else {
                setNewsData({ headerResponse: [] })

            }
        });
    }   

    const getItems = (type) => {        
        var filteredArray = dashboardWidgets.filter((item) => item.type === type);
        if (type === "DashboardTop") {
            filteredArray = filteredArray.filter((item) => dashboardTopOrder.includes(item.id))
                .sort((a, b) => dashboardTopOrder.indexOf(a.id) - dashboardTopOrder.indexOf(b.id));
        }
        if (type === "DashboardBottom") {     
            const widgetList = filteredArray; 
            filteredArray = filteredArray.filter((item) => dashboardBottomOrder.includes(item.id))
                .sort((a, b) => dashboardBottomOrder.indexOf(a.id) - dashboardBottomOrder.indexOf(b.id));
            var newWidget = widgetList.filter(item1 => !filteredArray.some(it => it.id === item1.id));
            if (newWidget.length > 0) { //checking and adding if new widget
                filteredArray.push(...newWidget);
            }
        };
        return filteredArray;
    }
        return (
            <>

                {loading ? <Loading type="brand" /> : storeData.settingsList.UseDashBoard == 1 ?
                    <div className="fele-home">
                        <div className={props.isFueling ? "active-panel-fueling" : "active-panel"}>
                            <div className="header-text">{dashboardLabels.DashboardHeaderText}</div>
                            <div >
                                <DraggableContainer styleClass="flex-container" type="DashboardTop" items={getItems("DashboardTop")}></DraggableContainer>
                                
                            </div>
                        </div>
                        <div className={props.isFueling ? "ffs-dashy-boi" : "dashy-boi"}></div>
                        <div>
                            <DraggableContainer styleClass="history-panel-container" type="DashboardBottom" items={getItems("DashboardBottom")}></DraggableContainer>                      
                        </div>
                    </div> : <div className="fele-home" style={{ textAlign: "center" }}>
                        <MessageStandard
                            icon={<SearchIcon />}
                            line1={storeData.labels.SearchPriceAndAvailabilityMessage}
                        />
                        {storeData.labels.SearchPriceAndAvailabilityDirections}

                    </div>

                }
            </>
        );
    };
//<DashboardYourSelections orderData={orderData} storeSettings={storeData} />  hiding until approved.
Home.propTypes = {
    selectedCustomer: PropTypes.object
};
function mapStateToProps(state) {
    return {  
        selectedCustomer: state.user.selectedCustomer
    };
}

export default connect(mapStateToProps, null)(withStorefrontConfig(withSelectedCustomer(withDashboardConfig(Home))));